import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Link } from '@honda-canada/design-system-react';
import themeStyles from './TimelineSharedUI.styles';
import { onTimelineNavClick } from '../service/utils';
const TimelineNavigationLink = themeStyles.apply(Link, 'TimelineNavigationLink');
const TimelineNavigationItem = ({ value, isActive, href, navSection, onClick, dataTestId, componentParameters, }) => {
    const onNavClick = (event) => {
        if (onClick) {
            onClick();
        }
        event.preventDefault();
        onTimelineNavClick(href);
    };
    return (_jsx(TimelineNavigationLink, { as: "button", "data-testid": dataTestId, onClick: onNavClick, navSection: navSection, isActive: isActive, ...componentParameters, children: value }));
};
export default TimelineNavigationItem;
